import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dbf38772&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbf38772')) {
      api.createRecord('dbf38772', component.options)
    } else {
      api.reload('dbf38772', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=dbf38772&", function () {
      api.rerender('dbf38772', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/desempenho/index.vue"
export default component.exports